import { apiProvider, apiMipe } from '@/core/api/';

export const getAcademicYear = async (academicYearId) => {
  return await apiMipe.get(
    `/api/academicyears/getacademicyearbyid/${academicYearId}`
  );
};

export const getAcademicYears = async () => {
  return await apiMipe.get('/api/academicyears');
};

export const getCurrentAcademicYear = async () => {
  return await apiMipe.get('/api/academicyears/current');
};

export const getFutureAcademicYear = async () => {
  return await apiMipe.get('/api/academicyears/future');
};

export const getCurrentAndNextAcademicYears = async () => {
  return await apiMipe.get('/api/academicyears/getcurrentandnextacademicyears');
};

export const getAvailableMonths = async (academicYearId) => {
  return await apiMipe.get(`/api/academicyears/${academicYearId}/months`);
};

export const getProviderProposalAreaAcademicYears = async () => {
  return await apiProvider.get('/api/providers/proposal/academicyears');
};

export const getSpecialistYears = async () => {
  return await apiMipe.get('api/academicyears/specialists');
};

export const getEffectiveAcademyYearsForAdmission = async (admissionId) => {
  return await apiMipe.get(
    `api/academicyears/effectiveacademicyears/${admissionId}`
  );
};

export const getAcademicYearsToCurrentYear = async () => {
  return await apiMipe.get('api/academicyears/getacademicyearstocurrentyear');
};

export const getAcademicYearsForServiceBudget = async () => {
  return await apiMipe.get(
    'api/academicyears/getAcademicYearsForServiceBudget'
  );
};

export const getAcademicYearsWithLoadProcess = async () => {
  return await apiMipe.get('api/academicyears/loadprocess');
};

export const getPeriodsWithLoadProcess = async (AcademicYearID) => {
  return await apiMipe.get(
    `api/academicyears/periodsloadprocess?academicYearId=${AcademicYearID}`
  );
};

export const getPeriodsByFiscalYears = async (AcademicYearID) => {
  return await apiMipe.get(
    `api/academicyears/periodsbyfiscalyear?academicYearId=${AcademicYearID}`
  );
};

export const getPreviousAcademicYears = async (AcademicYearID, take) => {
  return await apiMipe.get(
    `api/academicyears/previousacademicyears?academicYearId=${AcademicYearID}&take=${take}`
  );
};

export const getAcademicYearsToType = (yearType = 'CURRENT', minYearId = 22) =>
  apiMipe.get(
    `api/academicyears/academicyearfromin?yearType=${yearType}&minYearId=${minYearId}`
  );
